export default {
      id: "pdf-usage",
      viewBox: "0 0 23 46",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#pdf",
      toString: function () {
        return this.url;
      }
    }